// extracted by mini-css-extract-plugin
export default {"login-component":"style_login-component__-Zy-4","wrapper-login":"style_wrapper-login__S3H7G","login-module":"style_login-module__qkieT","login-form":"style_login-form__Ex8N-"};